<template>
  <div v-if="!loaded" class="d-flex height-100vh justify-center" :style="verticalPosition">
    <v-progress-circular indeterminate />
  </div>
</template>

<script>
const defaultVerticalPosition = { alignItems: "center" };

export default {
  name: "Loader",
  data() {
    return { verticalPosition: this.setVerticalPosition() };
  },
  methods: {
    setVerticalPosition() {
      return this.marginTop
        ? { marginTop: `${this.marginTop}%` }
        : defaultVerticalPosition;
    }
  },
  props: { loaded: Boolean, marginTop: Number }
};
</script>
